<lib-list-page
    [host]="this"
    title="UserData Types"
    icon="schema"
    searchPlaceholder="Search types…"
    totalIcon="schema"
    totalLabel="Types"
    emptyStateIcon="schema"
    emptyStateTitle="No UserData types match the current filter"
    emptyStateSubtitle="UserData types show up here automatically as data is ingested. Add some records on the User Data page to start populating the catalog.">

    <ng-container actions>
        <button mat-icon-button (click)="refreshData(true)" matTooltip="Refresh" aria-label="Refresh">
            <mat-icon>refresh</mat-icon>
        </button>
    </ng-container>

    <table mat-table table [dataSource]="dataSource()" class="data-table" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</th>
            <td mat-cell *matCellDef="let t">
                <a class="traversable" (click)="openType(t)">{{ t.type }}</a>
            </td>
        </ng-container>

        <ng-container matColumnDef="rowCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="rowCount" class="col-numeric">Rows</th>
            <td mat-cell *matCellDef="let t" class="col-numeric">{{ t.rowCount ?? 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="attributeCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="attributeCount" class="col-numeric">Attributes</th>
            <td mat-cell *matCellDef="let t" class="col-numeric">{{ t.attributeCount ?? 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="templateInCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="templateInCount" class="col-numeric">Templates (uses)</th>
            <td mat-cell *matCellDef="let t" class="col-numeric">{{ t.templateInCount ?? 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="templateOutCount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="templateOutCount" class="col-numeric">Templates (used by)</th>
            <td mat-cell *matCellDef="let t" class="col-numeric">{{ t.templateOutCount ?? 0 }}</td>
        </ng-container>

        <ng-container matColumnDef="lastActivity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="lastActivity">Last activity</th>
            <td mat-cell *matCellDef="let t">
                <span *ngIf="t.lastActivity">{{ t.lastActivity | date:'medium' }}</span>
                <span *ngIf="!t.lastActivity" class="muted">—</span>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="clickable-row"
            (click)="openType(row)"></tr>
    </table>

</lib-list-page>
